import React from 'react';
import { Link } from 'react-router-dom';
import Sheet from './ui/Sheet';
import { ChevronRightIcon } from './ui/icons';
import './RulesSheet.css';

interface RulesSheetProps {
  isOpen: boolean;
  onClose: () => void;
  /** Omitted when there is no share/resume disclosure to jump to (finalised
   *  crawl, or no resume code yet) — rule 5 then reads as plain text. */
  onShowShare?: () => void;
}

/**
 * Every crawl shows the same six rules — no per-crawl variation (§10).
 */
const RulesSheet: React.FC<RulesSheetProps> = ({ isOpen, onClose, onShowShare }) => (
  <Sheet isOpen={isOpen} onClose={onClose} title="Rules">
    <ol className="rules-sheet-list">
      <li>
        Scan the QR code at each pub. Start at any pub and visit them in <strong>any order</strong>.
        You should <strong>scan the QR codes before</strong> you start your drinks at all of the pubs <strong>except the last one</strong>: 
        there you should scan only when you've finished your drink
      </li>
      <li>
        Your timer starts when you make your <strong>first scan</strong> and stops after your
        <strong> last scan</strong>.

        At each pub, enjoy <strong>one drink</strong>—a pint of beer or cider, a glass of wine,
        a cocktail, a gin, a non-alcoholic drink, or even a cheeky shot. It's up to you!
      </li>
      <li>
        Leaderboard positions are ranked by the <strong>number of pubs visited first</strong>,
        then by your completion time. If you're running out of time, it may be worth
        squeezing in one more pub! You must visit at least <strong>two pubs</strong> to
        appear on the leaderboard.
      </li>
      <li>
        You have a maximum of <strong>12 hours</strong> to complete your crawl.
        After that, your session expires and you'll need to start a new crawl.
      </li>
      <li>
        {onShowShare ? (
          <button type="button" className="rules-sheet-jump" onClick={onShowShare}>
            Share your code or link
          </button>
        ) : (
          'Share your code or link'
        )}{' '}
        with friends so they can join your crawl, or use it
        yourself to continue the same session on another device or restore it if you
        lose your progress. <strong>Sharing your session does not extend the 12-hour time limit.</strong>
      </li>
    </ol>
    <div className="rules-sheet-foot">
      <Link to="/faqs" onClick={onClose}>
        <span>
          <b>Help and FAQs</b>
          <span>Having problems scanning a QR code or lost your progress?</span>
        </span>
        <ChevronRightIcon />
      </Link>
    </div>
  </Sheet>
);

export default RulesSheet;
